import { call, put, takeLatest } from 'redux-saga/effects'
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'
import { transfersFromCached } from '../../../lib/common'
import * as profitConstant from './constants'
import * as profitAction from './actions'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}
function nvkdRequestApi(formData) {
  const request = axiosApi().post(
    profitConstant.PROFIT_REPORT_NVKD_API,
    formData
  )

  return handleRequest(request);
}
function* profitReportNvkdRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(nvkdRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(profitAction.profitReportNvkdSuccess(results.data))

  } catch (error) {
    yield put(profitAction.profitReportNvkdError(error))
  }
}
function khRequestApi(formData) {
  const request = axiosApi().post(
    profitConstant.PROFIT_REPORT_KH_API,
    formData
  )

  return handleRequest(request);
}
function* profitReportKhRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const { data } = yield call(khRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(profitAction.profitReportKhSuccess(transfersFromCached(data)))

  } catch (error) {
    yield put(profitAction.profitReportKhError(error))
  }
}
function khoXuatRequestApi(formData) {
  const request = axiosApi().post(
    profitConstant.PROFIT_REPORT_KHOXUAT_API,
    formData
  )

  return handleRequest(request);
}
function* profitReportKhoXuatRequestFlow({ payload }) {
  try {
    // grab the client from our action
    const { data } = yield call(khoXuatRequestApi, payload)
    // dispatch the action with our widgets!
    yield put(profitAction.profitReportKhoXuatSuccess(transfersFromCached(data)))

  } catch (error) {
    yield put(profitAction.profitReportKhoXuatError(error))
  }
}
function listRequestApi(formData) {
  const request = axiosApi().post(
    profitConstant.PROFIT_REPORT_LIST_API,
    formData
  )

  return handleRequest(request);
}

function* profitReportListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(listRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(profitAction.profitReportListSuccess(results.data))

  } catch (error) {
    yield put(profitAction.profitReportListError(error))
  }
}

function exportXlsRequestApi(formData) {
  const url = profitConstant.PROFIT_REPORT_EXPORT_XLS_API + "?&st=" + formData.tu_ngay + "&ed=" + formData.den_ngay
    + "&ldh=" + formData.loaiDonHang + "&kd=" + formData.listNvkd + "&dtt=" + formData.daThanhToan
    + "&nkh=" + formData.listNhomKh + "&kh=" + formData.listKH + "&kx=" + formData.listKhoXuat + "&tt=" + formData.trangThai + "&kw=" + formData.keyword;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* reportExportXlsRequestFlow(action) {
  const { formData, callback } = action
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(profitAction.reportExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(profitAction.reportExportXlsError(error))
  }
}
function* profitReportNhomKhRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const request = axiosApi().post(
      profitConstant.PROFIT_REPORT_NHOMKH_API,
      payload
    )
    const results = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    yield put(profitAction.profitReportNhomKhSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(profitAction.profitReportNhomKhError(error))
  }
}
function* profitReportKhByNhomRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const request = axiosApi().post(
      profitConstant.PROFIT_REPORT_KH_BY_NHOM_API,
      payload
    )
    const results = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    yield put(profitAction.profitReportKhByNhomSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(profitAction.profitReportKhByNhomError(error))
  }
}
function* profitReportWatcher() {
  yield [
    takeLatest(profitConstant.PROFIT_REPORT_KHOXUAT_REQUESTING, profitReportKhoXuatRequestFlow),
    takeLatest(profitConstant.PROFIT_REPORT_NVKD_REQUESTING, profitReportNvkdRequestFlow),
    takeLatest(profitConstant.PROFIT_REPORT_KH_REQUESTING, profitReportKhRequestFlow),
    takeLatest(profitConstant.PROFIT_REPORT_LIST_REQUESTING, profitReportListRequestFlow),
    takeLatest(profitConstant.PROFIT_REPORT_EXPORT_XLS_REQUESTING, reportExportXlsRequestFlow),
    takeLatest(profitConstant.PROFIT_REPORT_NHOMKH_REQUESTING, profitReportNhomKhRequestFlow),
    takeLatest(profitConstant.PROFIT_REPORT_KH_BY_NHOM_REQUESTING, profitReportKhByNhomRequestFlow),
  ]
}

export default profitReportWatcher



// WEBPACK FOOTER //
// ./src/views/Reports/ProfitReport/sagas.js